import React, { useEffect, Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import RootRef from "@material-ui/core/RootRef";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import { List, ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import DragIndicatorRoundedIcon from "@material-ui/icons/DragIndicatorRounded";
import AddIcon from "@material-ui/icons/PostAdd";
import CloseIcon from "@material-ui/icons/CancelPresentation";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CheckLists from "./CheckLists";
import Grid from "@material-ui/core/Grid";
import Colors from "./../../Global/colors";
import DarkButton from "./../../Global/DarkButton";
import LightButton from "./../../Global/LightButton";
import CopyIcon from "@material-ui/icons/FileCopyOutlined";

import { Map } from "immutable";

// import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import "../../index.css";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: 10,
  },
  heading: {
    fontSize: theme.typography.pxToRem(20),
    // flexBasis: "33.33%",
    // flexShrink: 0,
    fontWeight: "500",
    color: "white",
    // fontFamily: "Roboto",
    // textAlign: "center",
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: Colors.globalColor8,
  },
  panelStyle: {
    //backgroundColor:"#0a66c2",
    backgroundColor: Colors.globalColor8,
    borderRadius: 2.5,
    color: "white",
  },
  header: {
    //backgroundColor:'#d9dadc'
    backgroundColor: Colors.backgroundColor,
  },
  dragableIcon: {
    width: 30,
    zIndex: 100,
    // top: 20,
    // left: 30,
    // position: "absolute",
  },
  actionableIcon: {
    width: 30,
    zIndex: 100,
    // top: 20,
    // left: 65,
    // position: "absolute",
    cursor: "pointer",
  },
  actionableDeteleIcon: {
    width: 30,
    zIndex: 100,
    // top: 20,
    // left: 85,
    // position: "absolute",
    cursor: "pointer",
  },
  actionableEditIcon: {
    width: 30,
    zIndex: 100,
    // top: 20,
    // left: 105,
    // position: "absolute",
    cursor: "pointer",
  },
  Icon: {
    width: 30,
    alignSelf: "center",
    cursor: "pointer",
    color: Colors.globalColor8,
  },
  hide: {
    display: "none",
  },
  show: {
    // alignSelf: "center",
    display: "block",
    // flexDirection: "row",
  },
  textBoxStyle: {
    fontWeight: "bold",
    // marginLeft: -theme.spacing.unit * 8,
    // paddingLeft: theme.spacing.unit,
    // width: 480,
    color: "white",
    border: "1px solid white",
  },
  divTypoStyle: {
    width: "100%",
    textAlign: "center",
  },
}));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};
const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    //background: "rgb(235,235,235)",
    background: "#fafafa",
    height: 80, //50
  }),
});
const getListStyle = (isDraggingOver) => ({
  //background: isDraggingOver ? "lightblue" : Colors.buttonTextColor,
  //padding: grid,
  //background:"#fafafa",
});

function diff(a, b) {
  var r = {};
  _.each(a, function(v, k) {
    if (b[k] === v) return;
    // but what if it returns an empty object? still attach?
    r[k] = _.isObject(v) ? _.diff(v, b[k]) : v;
  });
  return r;
}

class SectionContainer extends Component {
  // shouldComponentUpdate(nextProps, nextState) {
  //   // console.log(
  //   //   "SECTION CONTAINER",
  //   //   nextProps.section?.checklist?.list?.filter((v) => v.status !== "deleted")
  //   //     .length !==
  //   //     this.props.section?.checklist?.list?.filter(
  //   //       (v) => v.status !== "deleted"
  //   //     ).length
  //   // );
  //   return (
  //     nextProps.section?.checklist?.list?.filter((v) => v.status !== "deleted")
  //       .length ==
  //     this.props.section?.checklist?.list?.filter((v) => v.status !== "deleted")
  //       .length
  //   );
  // }
  

  render() {
    console.log("SECTION CONTAINER", this.props.section);
    return (
      <ExpansionPanelDetails style={{ backgroundColor: "white" }}>
        {this.props.section?.checklist?.list?.filter(
          (v) => v.status !== "deleted"
        ).length !== 0 && (
          <CheckLists
            HOCprops={this.props}
            setType={this.props.setType}
            template_id={this.props.template_id}
            section={this.props.section}
            activeSection={this.props.activeSection}
            checklist={
              this.props.section == undefined
                ? []
                : this.props.section.checklist
            }
            onUpdateChecklist={this.props.onUpdateChecklist}
            addNewQuestion={this.props.addNewQuestion}
            addNewCondition={this.props.addNewCondition}
            addNewSubQuestion={this.props.addNewSubQuestion}
            deleteCondition={this.props.deleteCondition}
            deleteSubQuestion={this.props.deleteSubQuestion}
            addNewLogicalQuestion={this.props.addNewLogicalQuestion}
            responseLibrary={this.props.responseLibrary}
            getResponseLibrary={this.props.getResponseLibrary}
          />
        )}
        {this.props.section?.checklist?.list?.filter(
          (v) => v.status !== "deleted"
        ).length == 0 && (
          <LightButton
            onClick={() => {
              console.log("hard-new", this.props.section?.id, "new");
              this.props.addNewQuestion(
                "hard-new",
                this.props.section?.id,
                "new"
              );
            }}
          >
            Add Question
          </LightButton>
        )}
      </ExpansionPanelDetails>
    );
  }
}

class Section extends React.Component {
  // shouldComponentUpdate(nextProps, nextState) {
  //   // console.log(
  //   //   nextProps.section?.checklist?.list?.filter((v) => v.status !== "deleted")
  //   //     .length !==
  //   //     this.props.section?.checklist?.list?.filter(
  //   //       (v) => v.status !== "deleted"
  //   //     ).length,
  //   //   nextProps.section?.checklist?.list?.filter((v) => v.status !== "deleted")
  //   //     .length,
  //   //   this.props.section?.checklist?.list?.filter((v) => v.status !== "deleted")
  //   //     .length
  //   // );
  //   return (
  //     nextProps.section.title !== this.props.section.title ||
  //     nextProps.responseLibrary !== this.props.responseLibrary ||
  //     nextProps.activeSection !== this.props.activeSection ||
  //     nextProps.section?.checklist?.list?.filter((v) => v.status !== "deleted")
  //       .length ===
  //       this.props.section?.checklist?.list?.filter(
  //         (v) => v.status !== "deleted"
  //       ).length
  //   );
  // }

  render() {
    return <SectionComponent {...this.props} />;
  }
}

const SectionComponent = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(true);
  const [edited, setEdit] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(!expanded);
  };
  const onEdit = (state) => {
    setEdit(!edited);
  };
  const addNewSection = async () => {
    await props.addNewSection(props.section.id);
    // await props.refreshComponent();
  };
  const copyNewSection = async () => {
    await props.copyNewSection(props.section.id);
    // await props.refreshComponent();
  };
  const handleTextChange = (event) => {
    props.updateSection(props.section.id, event.target.value, "update");
  };
  const deleteSection = () => {
    //alert('Call delete for '+props.section.id)
    props.updateSection(props.section.id, "", "delete");
    props.refreshComponent();
  };

  // console.log("rerender edit", props.section);
  return (
    <div className={classes.root}>
      <ExpansionPanel
        expanded={expanded}
        className={classes.header}
        style={{ border: "1px solid #dadada" }}
      >
        <ExpansionPanelSummary
          style={{ color: "white", backgroundColor: Colors.globalColor8 }}
          expandIcon={
            <ExpandMoreIcon
              className="expandcolor"
              onClick={handleChange(expanded)}
              style={{ color: "white" }}
            />
          }
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className={classes.panelStyle}
        >
          <Grid container style={{ alignItems: "center" }}>
            <Grid item xs={12} md={3}>
              <Grid container>
                {/* <Grid item>
                  <div
                    className={
                      props.section == undefined
                        ? classes.dragableIcon
                        : props.section.type == "section"
                        ? classes.dragableIcon
                        : classes.hide
                    }
                  >
                    <ListItemIcon>
                      <DragIndicatorRoundedIcon
                        style={{ color: Colors.buttonTextColor }}
                      />
                    </ListItemIcon>
                  </div>
                </Grid> */}
                <Grid item>
                  <div
                    className={
                      props.section == undefined
                        ? classes.actionableIcon
                        : props.section.type == "section"
                        ? classes.actionableIcon
                        : classes.hide
                    }
                  >
                    <Tooltip title="Add Section">
                      <ListItemIcon onClick={addNewSection}>
                        <AddIcon style={{ color: "white" }} />
                      </ListItemIcon>
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item>
                  <div
                    className={
                      props.section == undefined
                        ? classes.actionableDeteleIcon
                        : props.section.type == "section"
                        ? classes.actionableDeteleIcon
                        : classes.hide
                    }
                  >
                    <Tooltip title="Delete Section">
                      <ListItemIcon onClick={deleteSection}>
                        <DeleteIcon style={{ color: "white" }} />
                      </ListItemIcon>
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item>
                  <div
                    className={
                      props.section == undefined
                        ? classes.actionableEditIcon
                        : props.section.type == "section"
                        ? classes.actionableEditIcon
                        : classes.hide
                    }
                  >
                    <Tooltip title="Edit Section">
                      <ListItemIcon
                        onClick={() => {
                          onEdit(true);
                        }}
                      >
                        <EditIcon style={{ color: "white" }} />
                      </ListItemIcon>
                    </Tooltip>
                  </div>
                </Grid>
                <Grid item>
                  <div
                    className={
                      props.section == undefined
                        ? classes.actionableIcon
                        : props.section.type == "section"
                        ? classes.actionableIcon
                        : classes.hide
                    }
                  >
                    <Tooltip title="Copy Section">
                      <ListItemIcon onClick={copyNewSection}>
                        <CopyIcon style={{ color: "white" }} />
                      </ListItemIcon>
                    </Tooltip>
                  </div>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={8}>
              <Grid container>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <Typography
                    className={!edited ? classes.heading : classes.hide}
                  >
                    {props.section == undefined ? "" : props.section.title}
                  </Typography>

                  <div className={edited ? classes.show : classes.hide}>
                    <Grid
                      container
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Grid item>
                        <div className={classes.divTypoStyle}>
                          <TextField
                            id={
                              props.section == undefined ? 0 : props.section.id
                            }
                            className={[
                              "customField",
                              { className: classes.textBoxStyle },
                            ]}
                            InputProps={{ className: classes.textBoxStyle }}
                            size="small"
                            fullWidth
                            onChange={(e) => {
                              handleTextChange(e);
                            }}
                            value={
                              props.section == undefined
                                ? ""
                                : props.section.title
                            }
                            variant="outlined"
                          />
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.Icon}>
                          <Tooltip title="close editing">
                            <CancelIcon
                              onClick={() => {
                                onEdit(false);
                              }}
                              style={{ color: "white" }}
                            />
                            {/* <ListItemIcon
                              onClick={() => {
                                onEdit(false);
                              }}
                            >
                              <CloseIcon
                                style={{ color: "white" }}
                              />
                            </ListItemIcon> */}
                          </Tooltip>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ExpansionPanelSummary>

        <SectionContainer {...props} />
      </ExpansionPanel>
    </div>
  );
};
const ControlledExpansionPanels = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  //const [items,setItems]=React.useState(props.HOCprops.template)
  const [items, setItems] = React.useState([]);
  const [pagetitle, setPageTitle] = React.useState([]);
  const fillTemplate = () => {
    var list = [...props.sections];
    var index = list.findIndex((x) => x.type == "fixed section");
    var page_title = list[props.activeSection];
    setPageTitle(page_title);
    //list.splice(index,1)
    setItems(list);
  };
  React.useState(
    () => {
      fillTemplate();
    },
    [props.activeSection]
  );
  const [change, setChange] = React.useState(false);
  const refreshComponent = () => {
    setChange(true);
  };
  useEffect(
    () => {
      //setItems(props.HOCprops.template)
      fillTemplate();
      setChange(false);
      // fillTemplate();
      return;
    },
    [props.sections]
  );

  useEffect(
    () => {
      setPageTitle(props.sections[props.activeSection]);
    },
    [props.activeSection]
  );

  return (
    <div className={classes.root}>
      <Section
        props={props}
        section={Map(pagetitle).toObject()}
        setType={props.setType}
        template_id={props.template_id}
        onUpdateChecklist={props.onUpdateChecklist}
        addNewQuestion={props.addNewQuestion}
        addNewCondition={props.addNewCondition}
        addNewSubQuestion={props.addNewSubQuestion}
        deleteCondition={props.deleteCondition}
        deleteSubQuestion={props.deleteSubQuestion}
        addNewSection={props.addNewSection}
        updateSection={props.updateSection}
        refreshComponent={refreshComponent}
        addNewLogicalQuestion={props.addNewLogicalQuestion}
        responseLibrary={props.responseLibrary}
        getResponseLibrary={props.getResponseLibrary}
        copyNewSection={props.copyNewSection}
      />
    </div>
  );
};
export default ControlledExpansionPanels;
